<div class="wrapper">
        <header class="l-header">

                <div class="on-mobile header-logo">
                    <img src="assets/icons/logo.svg" alt="Artisan Sonics"/>
                </div>
                <div class="l-header-panel">
                  
                    <h1 class="t-title-main" style="margin-right: 32px;"> {{es.ExamType}} <span *ngIf="es.changedTitle">({{es.newTitle}})</span> {{pat.ID != 'default' ? (es.CreationTime| date:"dd/MM/yyyy") : "Defaults"}}</h1>
                    <i class="off-mobile header-icon icon-fetus" *ngIf="ps.fetusCt() > 1 && es.ExamType != 'Gynecology' && es.ExamType != 'Follicles'"></i>
        
                    <div class="header-pagi" *ngIf="ps.fetusCt() > 1 && es.ExamType != 'Gynecology' && es.ExamType != 'Follicles' && pat.ID != 'default' && ! ls.isCardio && ! ls.isGastro">
                        <span class="header-pagi-item" [ngClass]="es.getFetus() == 1? 'is-active':''" (click)="es.setFetus(1)">1</span>
                        <span class="header-pagi-item" [ngClass]="es.getFetus() == 2? 'is-active':''" (click)="es.setFetus(2)">2</span>
                        <span *ngIf="ps.fetusCt() > 2" class="header-pagi-item" [ngClass]="es.getFetus() == 3? 'is-active':''" (click)="es.setFetus(3)">3</span>
                        <span *ngIf="ps.fetusCt() > 3" class="header-pagi-item" [ngClass]="es.getFetus() == 4? 'is-active':''" (click)="es.setFetus(4)">4</span>
                    </div>
            
                    <nav class="header-menu" *ngIf="pat.ID != 'default'">
                        {{messages}}
                        <button class="search-btn search-btn--newPatient"
                          *ngIf="es.maccabiResend"
                          (click)="resendMaccabi()"
                          style="background: #dcb16b; padding-left: 1em; padding-right: 1em;"
                        >Resend report to Maccabi</button>
                        <ng-container *ngIf="es.clalit as cl">
                          <span *ngIf="cl.pending" class="clalit-pending">
                            Clalit cancellation scheduled for {{ clalitTime(cl.pending.dueKey) }}
                            <button class="search-btn search-btn--newPatient clalit-btn" *ngIf="cl.pending.status == 'scheduled'"
                              [disabled]="clalitBusy" (click)="undoClalitCancel()">Undo</button>
                          </span>
                          <button class="search-btn search-btn--newPatient clalit-btn" *ngIf="cl.canUpdate"
                            [disabled]="clalitBusy" (click)="clalitUpdate()"
                            matTooltip="Last sent {{ clalitTime(cl.lastSentKey) }}">Send update to Clalit</button>
                          <button class="search-btn search-btn--newPatient clalit-btn" *ngIf="cl.canSend && cl.cancelled"
                            [disabled]="clalitBusy" (click)="clalitResend()">Resend report to Clalit</button>
                          <button class="search-btn search-btn--newPatient clalit-btn clalit-btn--danger"
                            *ngIf="cl.canCancel && ls.category?.name == 'doctor'"
                            [disabled]="clalitBusy" (click)="openClalitCancel()">Cancel Clalit report</button>
                          <span *ngIf="cl.cancelled && !cl.pending" class="clalit-note">Cancelled at Clalit</span>
                          <span *ngIf="!cl.live && !cl.cancelled && cl.problem" class="clalit-note" [matTooltip]="cl.problem">Not sent to Clalit</span>
                          <span *ngIf="cl.warning" class="clalit-note clalit-note--error" [matTooltip]="cl.warning">
                            Clalit: patient ID is not valid - correct it{{ cl.live ? ' and send an update' : '' }}</span>
                          <span *ngIf="cl.lastFailure && !cl.pending" class="clalit-note clalit-note--error" [matTooltip]="cl.lastFailure.detail">
                            Clalit {{ cl.lastFailure.kind }} failed {{ clalitTime(cl.lastFailure.at) }}</span>
                          <span *ngIf="clalitMessage" class="clalit-note">{{ clalitMessage }}</span>
                        </ng-container>
                        <a class="header-menu-link" [ngClass]="isRecording()? 'icon-stop': 'icon-record'" aria-label="Record" (click)="record()" *ngIf="! es.isClosed && ! es.isForm && Stream && (ls.ishospital || ls.hasPremission('VideoRecording'))" matTooltip="Start/Stop Recording"></a> 
                        <span (click)="showprintopts=true;showprint=true" class="header-menu-link icon-print" aria-label="Print" matTooltip="Print" *ngIf="es.ExamType != 'Emergency Room' && signatureService.isExamSigned(es.examObject) "></span>
                        <span
                        *ngIf="!signatureService.isExamSigned(es.examObject)"
                        (click)="showprintopts = false; showprint = true"
                        class="header-menu-link icon-searchdoc"
                        aria-label="Print Preview"
                        matTooltip="Print Preview"
                      ></span>
                      <img
                        class="header-menu-link print-history-icon"
                        src="../../assets/icons/print-history.svg"
                        aria-label="Previous Reports"
                        matTooltip="{{ 'GUI.Patient History.PrintHistory.Open Print History' | translate }}"
                        (click)="showPrintHistory = true"
                        *ngIf="ls.hasPremission('PrintExamHistoryInExam')"
                      />
                      <div *ngIf="signatureService.isExamSigned(es.examObject)">
                        <button
                          class="header-menu-link"
                          [ngClass]="sendonce ? 'icon-link-sent' : 'icon-link'"
                          aria-label="Link"
                          (click)="showlink = true"
                          matTooltip="Send Weblink to patient"
                        ></button>
                        <span
                          *ngIf="ls.getPremission('LinkLimit')"
                          style="align-self: center; margin-inline-start: 2.31em"
                          [ngClass]="ls.linksent >= ls.getPremission('LinkLimit') ? 'error' : ''"
                        >
                          {{ ls.linksent }}/{{ ls.getPremission('LinkLimit') }}
                        </span>
                      </div>
                        <ng-container *ngIf="! es.isForm">
                            <a class="header-menu-link"  [ngClass]="messages !='Creating Disk ...'? 'icon-save': 'icon-busy'" aria-label="Disk" (click)="getDisk()" matTooltip="Burn CD"></a>
                            <span class="header-menu-link icon-image" aria-label="Images" (click)="showgallery=!showgallery" matTooltip="Open Gallery"></span>
                            <span *ngIf="dicomStudies > 0"
                              class="header-menu-link icon-dicom"
                              role="button"
                              aria-label="DICOM viewer"
                              (click)="openDicomViewer()"
                              [matTooltip]="dicomStudies > 1 ? 'Open DICOM Viewer (' + dicomStudies + ' studies)' : 'Open DICOM Viewer'"></span>
                            <img
                            style="cursor: pointer;"
                            class="header-menu-link "
                            matTooltip="Attached Documents"
                            height="35em"
                            width="35em"
                            (click)="openDocumentsAdd=true"
                            src="../../assets/icons/fileupload.svg"
                            matTooltip="Attach Document"
                          />
                            <span class="header-menu-link icon-inbox" aria-label="Inbox" (click)="showInbox=! showInbox" matTooltip="Open Inbox"></span>
                            
                            <a class="header-menu-link icon-searchdoc" aria-label="Search" *ngIf="false"></a>
                            <span *ngIf="! es.isClosed && vidMinified && Stream" (click)="vidMinified=false" style='margin-left:2em'>
                                <video id='minviewer' style='height: 35px;' playsinline autoplay [srcObject]="Stream"  ></video>
                                <meter [high]="0.25" max="1" [value]="audioLevel / 100" class="vertical"></meter>
                                <div style='position: absolute; color: white; font-size: 7pt; margin-top: -4.5em'>{{ts.time}}</div>
                            </span>
                        </ng-container>
                        <a class="header-menu-link icon-confirm" aria-label="Confirm" (click)="handleClose('/patsearch')" matTooltip="Close Exam and Open AWL"></a> 
                    </nav>
                    <a *ngIf="pat.ID == 'default'" class="header-menu-link icon-confirm" aria-label="Confirm" (click)="handleClose('/patsearch')" matTooltip="Close Exam and Open AWL" style="margin-left: auto;"></a>
        
                    <nav class="on-mobile header-mobilePanel">
                        <button class="btn-mobileMenu" id="open-headerMenu" data-show=".header-menu"></button>
                        <button class="btn-mobileMenu" id="open-mainNav" data-show=".l-sidebar"></button>
                    </nav>			
        
                </div>
            
            </header>
        
    
        <div class='exam-element'>
            <div class='topbar' *ngIf="! es.OpenerName || es.ExamType != 'Emergency Room'"></div>
            <div class='topbar' *ngIf="es.OpenerName && es.ExamType == 'Emergency Room'">Examined By: {{es.OpenerName}}</div>
            <main class="l-deashboard">
                <app-pregnancy *ngIf="page=='Pregnancy'" (setFetuses)="changeFetuses($event)"></app-pregnancy>
                <app-placenta *ngIf="page=='Placenta'"></app-placenta>
                <app-nt *ngIf="page=='NT'"></app-nt>
                <app-doppler *ngIf="page=='Obs Doppler'"></app-doppler>
                <app-measurements *ngIf="page=='Measurements'" [fetus]="this.fetuses"></app-measurements>
                <app-anatomy *ngIf="page=='Anatomy'"></app-anatomy>
                <app-gyngeneral *ngIf="page=='Introduction' && ! ls.isCardio"></app-gyngeneral>
                <app-cardio-general *ngIf="page=='Introduction' && ls.isCardio"></app-cardio-general>
                <app-uterus *ngIf="page=='Uterus'"></app-uterus>
                <app-ovaries *ngIf="page=='Ovaries'"></app-ovaries>
                <app-procedure *ngIf="page=='Procedure'"></app-procedure>
                <app-consultation *ngIf="page=='forms'"></app-consultation>
                <app-summary *ngIf="page=='Summary' && ! ls.isCardio"></app-summary>
                <app-cardio-summary *ngIf="(page=='Summary' && ls.isCardio) ||(page=='Introduction' && (es.ExamType=='Pulmonary functional assessment' || es.ExamType=='Methacholine test')) "></app-cardio-summary>
                <app-gallerybox *ngIf="showgallery" (closed)="showgallery=false;CurrentInbox=null" (closeall)="showgallery=false;CurrentInbox=null;showInbox=false" [inbox]="CurrentInbox"></app-gallerybox>
                <app-charts *ngIf="showcharts" (closed)="showcharts=false" [page]="page"></app-charts>
                <app-inbox *ngIf="showInbox" (closed)="showInbox=false" (openg)="openGallery($event)"></app-inbox>
                <app-printopts *ngIf="showprint" (closed)="showprint=false" [showopts]="showprintopts"></app-printopts>
                <app-exam-print-history *ngIf="showPrintHistory" (closed)="showPrintHistory=false"></app-exam-print-history>
                <app-send-link *ngIf="showlink" (closed)="showlink=false;sendonce=true;ls.countLinks()" [exam]="null"></app-send-link>
                <app-gallery style='width: 100%' [forprint]="false" [inbox]="null" *ngIf="es.ExamType == 'Emergency Room'"></app-gallery>
                <app-twod *ngIf="page=='2D Measurements'"></app-twod>
                <app-cardio-doppler *ngIf="page == 'Doppler'"></app-cardio-doppler>
                <app-cardio-tissue-dop *ngIf="page == 'Tissue Doppler'"></app-cardio-tissue-dop>
                <app-preparation *ngIf="page=='Preparation'"></app-preparation>
                <app-findings *ngIf="page=='Findings' && ls.isGastro"></app-findings>
                <app-pathologies *ngIf="page=='Pathologies'"></app-pathologies>
                <app-cardio-findings 
                  [updateExercise$]="updateExercise$" 
                  *ngIf="page=='Findings' && ls.isCardio">
                </app-cardio-findings>
                <app-gastro-procedure *ngIf="page == 'ProcedureGastro'"></app-gastro-procedure>
                <app-gastro-summary *ngIf="page=='SummaryGastro'"></app-gastro-summary>
                <app-commerror></app-commerror>
            </main>
        </div>
        <app-informconcent *ngIf="inform" (closed)="closeConcent($event)" [form]="concentForm" [ExamType]="es.ExamType"></app-informconcent>

        
        <aside class="l-moreInfo" *ngIf="es.ShowSRs">

                <div class="moreInfo-partialyObscured">
        
                    <section class="m-box">
                        <h2>
                            Structured reports
                        </h2>
                        <p>
                            <ng-container *ngFor="let sr of es.SRList; let i=index">
                                <span (click)="loadSR(sr)" [ngClass]="CurrentSR == sr? 'srselected' : 'sritem'">{{i + 1}}</span>&nbsp; 
                            </ng-container>

                            <!-- sandbox with no allow-* tokens: opaque origin, no scripts,
                                 no forms, no top-level navigation. The report only needs
                                 CSS, which sandboxing does not restrict. -->
                            <iframe *ngIf="CurrentSR" [srcdoc]="SR" sandbox
                                style='width: 100%; height: 63vh; padding-bottom: 2em; border: 0; background: #fff'></iframe>

                        </p>
                        
                    </section>
        
                </div>
        
            </aside>
           
                    <app-examsbar (pageChange)="setPage($event)" (showPatDetails)="showPat=true"></app-examsbar>
                    <app-patdetails
                    *ngIf="showPat"
                    [pat]="pat"
                    (closed)="showPat = false"
                    [currentTab]="page" 
                    (updateExercise)="handleUpdateExercise()"
                  ></app-patdetails>
                    <app-bottombar></app-bottombar>
                    <app-pat-documents *ngIf="openDocumentsAdd" [showDocuments]="true"  (closed)="openDocumentsAdd = false;" ></app-pat-documents>
</div>
<app-autotext *ngIf="atS.Display"></app-autotext>


<div style="position: absolute;bottom:0; right: 0; z-index:100;" *ngIf="! es.isClosed && ls.Recording == 'webrtc' &&! vidMinified"  >
    <div style='position: absolute;top:0;left:0'>
        <img src="../../assets/icons/minimize.svg" style='width: 30px' (click)="vidMinified = true" matTooltip="Minimize">
        <img src="../../assets/icons/maximize.svg" style='width: 30px' (click)="maximizeVid()" matTooltip="Full Screen">
    </div>
    <meter style="width: 60%; margin-top: 2em;" [high]="0.25" max="1" [value]="audioLevel / 100"></meter>
    <span #videobox (fullscreenchange)="togglefullscreen()">
        <video playsinline autoplay [srcObject]="Stream" *ngIf="Stream" #video [class]="fullscreen? 'fullscreen':'vscreen'"></video>
        <div style="font-size: 22pt;color: white;position: absolute;margin-top: -5em; z-index: 200;direction: ltr;" *ngIf="isRecording()">{{ts.time}}</div>
    </span>
    <div style="position: absolute;margin-top: -5em; z-index: 200; color: white;direction: ltr;">
        
            <span *ngIf="! isRecording() && ! ls.RemoteRTC">
                <div><select [(ngModel)]="videoSource" (change)="startVideo()">
                    <ng-container *ngFor="let item of videoInputs">
                        <option [value]="item.value">{{item.text}}</option>
                    </ng-container>
                </select>
                </div>
                <select [(ngModel)]="audioSource" (change)="startVideo()">
                    <ng-container *ngFor="let a of audioInputs">
                        <option [value]="a.value">{{a.text}}</option>
                    </ng-container>
                </select>
                Sound Test <input type="checkbox" [(ngModel)]="soundtest" [value]="true" (change)="startVideo()">
            </span>
            
            <span style="color: red; display: none" *ngIf="videowarn">No Video Device found!</span>
        </div>
</div>

<!-- ======= Alert to sign the exam (Start) ======= -->
<div
  class="t-popup popup-patientDetails"
  *ngIf="showAlertToSign"
  style="display: block; max-width: 40vw"
>
  <div class="t-popup-close"></div>

  <div class="t-popup-frame">
    <div class="t-popup-body">
      <button
        class="t-btn-popup-close"
        aria-label="close popup"
        (click)="showAlertToSign = false"
      ></button>

      <h2 style="color: #d7a95b">
        You are about to leave an unsigned {{ es.ExamType === 'Consultation Letter' ? 'letter' : 'exam'}} - the report won't be able to be printed {{ es.ExamType === 'Consultation Letter' ? '' : ', nor will it be sent to the HMO.'}}
       <br />
        To continue, please sign the {{ es.ExamType === 'Consultation Letter' ? 'letter' : 'exam'}}.
      </h2>
      <div>
        <button (click)="showAlertToSign = false" class="blue-btn">Stay</button>
        <button
          (click)="leaveSignAlert()
          "
          class="orange-btn"
          style="margin-left: 2em"
        >
          Leave
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ======= Alert to sign the exam (End) ======= -->

<div class="clalit-confirm" *ngIf="clalitConfirm && es.clalit">
    <div class="clalit-confirm-box">
        <h2>Cancel the report sent to Clalit</h2>
        <p>
            {{ es.ExamType }} for {{ pat?.First }} {{ pat?.Last }} ({{ pat?.ID }}) was sent to Clalit on
            <b>{{ clalitTime(es.clalit.lastSentKey) }}</b><span *ngIf="es.clalit.firstSentKey && es.clalit.firstSentKey != es.clalit.lastSentKey">
            (first sent {{ clalitTime(es.clalit.firstSentKey) }})</span>.
        </p>
        <p>
            Clalit will remove this report from the patient's file. The cancellation is sent in
            {{ es.clalit.cancelDelayMinutes }} minutes, and can be stopped from this screen until then.
        </p>
        <label class="clalit-confirm-ack">
            <input type="checkbox" [(ngModel)]="clalitAck">
            Cancel the report sent on {{ clalitTime(es.clalit.lastSentKey) }}
        </label>
        <div class="clalit-confirm-actions">
            <button class="search-btn search-btn--newPatient clalit-btn--danger" [disabled]="!clalitAck || clalitBusy" (click)="confirmClalitCancel()">Schedule cancellation</button>
            <button class="search-btn search-btn--newPatient" (click)="clalitConfirm = false">Keep the report</button>
        </div>
    </div>
</div>
